var map = {
	"./bottom-nav-bg.png": 1305,
	"./bottom-nav-bg.webp": 1306,
	"./btn-active.png": 1307,
	"./btn-deco.webp": 1308,
	"./content-deco-1.webp": 1309,
	"./content-deco-2.webp": 1310,
	"./content-deco-3.webp": 1311,
	"./content-deco-4.webp": 1312,
	"./content-deco-5.webp": 1313,
	"./content-deco-6.webp": 1314,
	"./convenient.webp": 1315,
	"./deposit-icon.webp": 1316,
	"./home-icon-active.webp": 1317,
	"./home-icon.webp": 1318,
	"./live-icon-active.webp": 1319,
	"./live-icon.webp": 1320,
	"./me-icon-active.webp": 1321,
	"./me-icon.webp": 1322,
	"./product-overview-bg.webp": 1323,
	"./professional.webp": 1324,
	"./promos-icon-active.webp": 1325,
	"./promos-icon.webp": 1326,
	"./raya-bg.png": 1327,
	"./safety.webp": 1328,
	"./services-bg.png": 1329,
	"./speed.webp": 1330,
	"./sponsor-icon-active.webp": 1331,
	"./sponsor-icon.webp": 1332,
	"./vip-icon.webp": 1333,
	"./withdraw-icon.webp": 1334,
	"./wwr-img.webp": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;